<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {}
}
</script>
<style lang="stylus">
#videoContainer
  *
    font-family none!important
input, select, textarea, button
    -webkit-appearance: none
input:-webkit-autofill
    -webkit-box-shadow 0 0 0px 100px white inset
html
  -webkit-overflow-scrolling touch
</style>
